import React from 'react';

const AboutSection = () => {
  return (
    <div className="container" id="about">
      <section>
        <div className="row d-flex align-items-center h-100 mt-5 pt-5">
          <div className="col-md-5" style={{ marginTop: '-74px' }}>
            <h2
              className="text-uppercase h1 mb-5"
              style={{ color: '#D27F67', letterSpacing: '3px' }}
            >
              THE BITEJOY...
            </h2>
            <p className="lead mb-4">
              At Bitejoy Chocolates, we believe chocolate should be more than
              just a sweet treat it should be a joyful experience filled with
              goodness.
            </p>
            <p className="lead mb-0">
              Our journey began with a simple idea: to create chocolates that
              balance taste, nutrition, and quality. Every Bitejoy chocolate is
              handcrafted with care, using premium ingredients and a thoughtful
              process that takes care of everything from sourcing to packaging.
            </p>
            <p className="lead mb-0">
              We proudly follow an A-to-Z in-house process, ensuring freshness,
              purity, and consistency in every bite. With the blessings of Bappa
              and the love of our customers, we are building a brand that stands
              for honesty, innovation, and happiness. Bitejoy Chocolates are made
              for everyone kids, adults, fitness lovers, and families who want
              guilt-free indulgence without compromising on taste.
            </p>
          </div>
          <div className="col-md-6 offset-md-1 mt-4" style={{ marginTop: '-18px' }}>
            <img
              src="/images/Bitejoy/1767900045680.jpg"
              className="img-fluid about-image"
              alt="about"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutSection;
